import axios from 'axios';
const headers = {
	Authorization: 'Bearer ' + process.env.REACT_APP_APPI_KEY,
};
export default axios.create({
	baseURL: process.env.REACT_APP_MERAKI_CMS,
	headers,
	responseType: 'json',
});
